import React from "react";
import { Switch } from "antd";
import { get, set } from "../../../utils";
import { YxComponent } from "../../YxComponent";

export default class extends YxComponent {
  constructor(props, content) {
    super(props, content);
    this.state = {
      checked: get(this.props, "defaultValue", false),
    };
  }

  onChange = (checked, ...args) => {
    this.setState({ checked });
    get(this.props, "onChange", () => {})(checked, ...args);
  };

  render() {
    return (
      <Switch
        {...this.props}
        checked={this.props.value}
        onChange={this.onChange}
      ></Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxSwitch/Switch.js